import React, { useEffect, useState } from "react"

import { Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { useExternalDemoMode } from "../../hooks/useExternalDemoMode"
import Icon from "../../Icon"
import Images from "../../Images"
import ButtonComponent from "../Button"

const { Text } = Typography

const FeedbackModal = ({ count }) => {
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const userInfo = useSelector((store) => store?.auth?.userInfo)
  const { bannerInfo, businessAccount } = useSelector((state) => state.user)
  const [modalVisible, setModalVisible] = useState(false)
  const externalDemoMode = useExternalDemoMode()

  const sumModalFeedback = businessAccount?.connected_payment_processors?.includes("shopify")
    ? 50
    : 29

  useEffect(() => {
    const isFeedbackModalAlreadyWasShown = localStorage.getItem("feedbackModalShown") === "true"
    if (
      !isFeedbackModalAlreadyWasShown &&
      !userInfo?.is_demo &&
      count >= 2 &&
      !externalDemoMode &&
      !bannerInfo?.is_loyalty_billing
    ) {
      setModalVisible(true)
    }
  }, [count, bannerInfo?.is_loyalty_billing])

  const handleCloseModal = () => {
    setModalVisible(false)
    localStorage.setItem("feedbackModalShown", true)
  }

  const handleSubmitFeedback = () => {
    handleCloseModal()
  }

  return (
    <Modal
      {...(isMobile ? { transitionName: "" } : null)}
      open={modalVisible}
      centered={!isMobile}
      width={442}
      title={`${t("Submit feedback and get $_sum_ balance", { sum: sumModalFeedback })}`}
      footer={null}
      closeIcon={<Icon type="cross_small" style={{ color: "#7A7A83" }} />}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{
        content: "clear-bg full-width-header"
      }}
    >
      <Flex gap={16} vertical={true} justify={"center"} align={"center"}>
        <Flex justify={"center"} align="center" style={{ width: "100%", position: "relative" }}>
          <img
            alt="chargebee_step_1.webp"
            src={Images["feedback_modal_bg"]}
            style={{ width: "100%", height: "auto", display: "block", borderRadius: 16 }}
          />
          <Text
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              color: "#225AEA",
              fontSize: 18,
              textAlign: "center",
              fontWeight: 800,
              textTransform: "uppercase"
            }}
          >
            {`$${sumModalFeedback} ${t("Balance Gift")}`}
          </Text>
        </Flex>

        <Flex vertical={true} gap={20}>
          <Text type="secondary">
            <Text type="secondary" strong>
              {t("We value your feedback!")}
            </Text>{" "}
            {t(
              "Share your honest thoughts about our platform. It takes under 30 seconds. As a thank you, we will add $_sum_ to your balance.",
              { sum: sumModalFeedback }
            )}
          </Text>
          <Text type="secondary">
            {t("Click below to submit your feedback and claim your reward.")}
          </Text>
          <Flex vertical gap={4}>
            <Text type="secondary">{t("Please note")}</Text>
            <Text type="secondary">
              • {t("We are looking for real, thoughtful feedback")} <br />•{" "}
              {t("Unserious or low effort responses will not receive the reward")}
            </Text>
          </Flex>
        </Flex>

        <Flex gap={12} style={{ width: "100%", margin: "24px 0 12px", padding: "0 2px" }}>
          <ButtonComponent
            size="large"
            type="primary"
            className="flex center"
            onClick={handleSubmitFeedback}
            block
            href={"https://leavefeedback.typeform.com/chargeback"}
            target="_blank"
          >
            {t("Submit feedback")}
          </ButtonComponent>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default React.memo(FeedbackModal)
